import React from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { openSearchModal } from "@/modules/hub/features/Search/slices/searchSlice";
import { RootState } from "@/app/rootReducer";
import { selectActiveSessionCompanyName } from "@/modules/hub/features/UserAppSettings/selectors/userAppSettingsSelectors";

const HubHero: React.FC = () => {
  const dispatch = useDispatch();
  const userAppSettings = useSelector(
    (state: RootState) => state.userAppSettings.userAppSettings,
  );
  const companyName = useSelector(selectActiveSessionCompanyName);

  const firstName = userAppSettings?.firstName || "there";
  const displayCompanyName = companyName || "your hub";

  const handleSearchClick = () => {
    dispatch(openSearchModal());
  };

  return (
    <div className="relative overflow-hidden">
      <div className="relative mx-auto max-w-5xl px-4 pt-12 pb-4 sm:px-6 md:pt-16 md:pb-6">
        <div className="text-center">
          {/* Headline - With subtle gradient for depth */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-wide mb-5 bg-gradient-to-b from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent">
            Welcome back, {firstName}
          </h1>

          {/* Hero Search Bar - Elevated glass morphism */}
          <div className="mx-auto max-w-xl">
            <button
              className="group relative w-full"
              onClick={handleSearchClick}
              type="button"
            >
              {/* Glow effect behind search bar */}
              <div className="absolute -inset-1 bg-gradient-to-r from-primary/20 via-primary/10 to-primary/20 dark:from-primary/30 dark:via-primary/15 dark:to-primary/30 rounded-xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative flex items-center rounded-xl border border-gray-200 dark:border-white/10 bg-white/80 dark:bg-white/5 backdrop-blur-xl px-5 py-4 shadow-lg shadow-gray-200/50 dark:shadow-black/20 transition-all duration-300 hover:border-gray-300 dark:hover:border-white/20 hover:shadow-xl hover:shadow-gray-200/60 dark:hover:shadow-black/30">
                <MagnifyingGlassIcon
                  aria-hidden="true"
                  className="h-5 w-5 text-gray-400 transition-colors group-hover:text-primary dark:group-hover:text-white"
                />
                <span className="ml-4 flex-1 text-left text-base text-gray-500 dark:text-gray-300 group-hover:text-gray-700 dark:group-hover:text-white transition-colors">
                  Search events, resources, news...
                </span>
                <kbd className="hidden sm:inline-flex items-center gap-1 rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100/80 dark:bg-white/10 px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-300">
                  <span className="text-sm">⌘</span>K
                </kbd>
              </div>
            </button>

            {/* Helper Text */}
            <p className="mt-3 text-xs text-gray-400 dark:text-gray-500 font-light">
              Press{" "}
              <kbd className="rounded border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-800/50 px-1.5 py-0.5 text-xs font-medium text-gray-500 dark:text-gray-400">
                ⌘K
              </kbd>{" "}
              to search from anywhere
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubHero;
